"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SSPScalemode = void 0;
var tslib_1 = require("tslib");
var SSPContentVO_1 = tslib_1.__importDefault(require("./model/SSPContentVO"));
var ReqUtil_1 = require("./util/ReqUtil");
var toLccc_1 = require("./util/toLccc");
var SSPScalemode;
(function (SSPScalemode) {
    SSPScalemode["FIT"] = "fit";
    SSPScalemode["CROP"] = "crop";
})(SSPScalemode = exports.SSPScalemode || (exports.SSPScalemode = {}));
var SSPContentExt = (function () {
    function SSPContentExt() {
        this._rawCache = {};
        this._modelCache = {};
        this._projectUid = null;
        this._lcCC = toLccc_1.toLccc('de', 'DE');
        this._sspUrl = '';
    }
    Object.defineProperty(SSPContentExt, "instance", {
        get: function () {
            if (!SSPContentExt._instance) {
                SSPContentExt._instance = new SSPContentExt();
            }
            return SSPContentExt._instance;
        },
        enumerable: false,
        configurable: true
    });
    SSPContentExt.prototype.configure = function (sspurl) {
        if (!sspurl.endsWith('/')) {
            sspurl += '/';
        }
        this._sspUrl = sspurl;
        return this;
    };
    SSPContentExt.prototype.initWithDevice = function (uid) {
        return this.initWithJsonURL("/data/allContents.json");
        //return this.initWithJsonURL("" + this._sspUrl + SSPContentExt.SSP_BASE_ROUTE + "/terminals/" + uid + "/allcontents.json");
    };
    SSPContentExt.prototype.initWithJsonURL = function (url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                    ReqUtil_1.httpReq('GET', url, null).then(function (req) {
                        if (req.status === 200) {
                            var models = JSON.parse(req.response);
                            _this.initData(models);
                            resolve();
                        } else {
                            reject();
                        }
                    }).catch(function () {
                        reject();
                    });
                })];
            });
        });
    };
    SSPContentExt.prototype.initWithModels = function (models) {
        this.initData(models);
    };
    SSPContentExt.prototype.initData = function (models) {
        this._rawCache = {};
        this._modelCache = {};
        this._projectUid = null;
        for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
            var model = models_1[_i];
            this._rawCache[model.Uid] = model;
            if (this._projectUid === null && model.ContentType === 'project') {
                this._projectUid = model.Uid;
            }
        }
    };
    Object.defineProperty(SSPContentExt.prototype, "projectModel", {
        get: function () {
            if (this._projectUid) {
                return this.getContentModel(this._projectUid);
            }
            return new SSPContentVO_1.default('project');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPContentExt.prototype, "startModel", {
        get: function () {
            if (this.projectModel) {
                return this.projectModel.asModel.ref('root_content');
            }
            return new SSPContentVO_1.default('start');
        },
        enumerable: false,
        configurable: true
    });
    SSPContentExt.prototype.getContentModel = function (uid) {
        if (!(uid in this._modelCache)) {
            if (uid in this._rawCache) {
                this._modelCache[uid] = new SSPContentVO_1.default(uid).applyJson(this._rawCache[uid]);
            } else {
                this._modelCache[uid] = new SSPContentVO_1.default(uid);
            }
        }
        return this._modelCache[uid];
    };
    SSPContentExt.prototype.modelExists = function (uid) {
        return uid in this._rawCache;
    };
    SSPContentExt.prototype.getAssetUrl = function (hash) {
        if (this._sspUrl !== '') {
            return "" + this._sspUrl + SSPContentExt.SSP_BASE_ROUTE + "/asset/" + hash;
        }
        return "asset/" + hash;
    };
    SSPContentExt.prototype.getThumbUrl = function (uidOrHash, width, height, scalemode) {
        if (scalemode === void 0) {
            scalemode = SSPScalemode.FIT;
        }
        var hash = uidOrHash;
        if (hash.length === 37) {
            var model = this.getContentModel(uidOrHash);
            if (model.isAsset) {
                hash = model.asAsset.posterFileExists ? model.asAsset.posterFileProperties.fileHash : model.asAsset.fileProperties.fileHash;
            } else {
                hash = 'invalid';
            }
        }
        var thumbUrl = this.getAssetUrl(hash);
        if (!this._sspUrl) {
            return thumbUrl;
        }
        return thumbUrl + "?width=" + width + "&height=" + height + "&scalemode=" + scalemode;
    };
    SSPContentExt.prototype.getContentModels = function () {
        return this.getContentModelsByType(null);
    };
    SSPContentExt.prototype.getContentModelsByType = function (contentTypeAsStringOrRegex) {
        var regex;
        if (contentTypeAsStringOrRegex instanceof RegExp) {
            regex = contentTypeAsStringOrRegex;
        } else if (typeof (contentTypeAsStringOrRegex) === 'string') {
            regex = new RegExp(contentTypeAsStringOrRegex, 'i');
        } else {
            regex = new RegExp('.*');
        }
        var models = new Array();
        for (var _i = 0, _a = Object.keys(this._rawCache); _i < _a.length; _i++) {
            var uid = _a[_i];
            if (regex.test(this._rawCache[uid].ContentType)) {
                models.push(this.getContentModel(uid));
            }
        }
        return models;
    };
    SSPContentExt.prototype.getContentModelsReferencing = function (uid, contentTypeAsStringOrRegex) {
        if (contentTypeAsStringOrRegex === void 0) {
            contentTypeAsStringOrRegex = null;
        }
        if (!this.modelExists(uid)) {
            return new Array();
        }
        var models = this.getContentModelsByType(contentTypeAsStringOrRegex).filter(function (model) {
            return model.asFolder.hasChild(uid) || model.asModel.references(uid);
        });
        return models;
    };
    SSPContentExt.prototype.getContentModelReferencing = function (uid, contentTypeAsStringOrRegex) {
        if (contentTypeAsStringOrRegex === void 0) {
            contentTypeAsStringOrRegex = null;
        }
        var models = this.getContentModelsReferencing(uid, contentTypeAsStringOrRegex);
        if (models.length > 0) {
            return models[0];
        } else {
            return null;
        }
    };
    SSPContentExt.prototype.setCurrentLanguage = function (lcOrLccc, cc) {
        if (cc === void 0) {
            cc = null;
        }
        this._lcCC = toLccc_1.toLccc(lcOrLccc, cc);
        return this;
    };
    SSPContentExt.prototype.getCurrentLanguage = function () {
        return this._lcCC;
    };
    SSPContentExt.prototype.getSSPUrl = function () {
        return this._sspUrl;
    };
    SSPContentExt.SSP_BASE_ROUTE = 'module/content/api/v1/depot';
    return SSPContentExt;
}());
exports.default = SSPContentExt;